
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from "next"
import Head from "next/head"

import getFilters from "@/graphql/requests/getFilters"
import SEO from "@/meta/SEO"
import { GoogleAnalytics } from "@/services/GA4/GoogleAnalytics"
import Default from "@/templates/Default"
import FansiKind from "@/ts/enums/global/FansiKind"
import ProductType from "@/ts/enums/product/ProductType"
import FilterGroup from "@/ts/interfaces/global/FilterGroup"
import ProductsView from "@/views/products"
import useStaticProducts from "@/views/products/functions/useStaticProducts"

const PRODUCT_TYPE = ProductType.Digital

function DigitalProductsPage({
  staticFilters,
}: {
  staticFilters: FilterGroup
}) {
  const { filters } = useStaticProducts({
    staticFilters,
    productType: PRODUCT_TYPE,
  })

  if (!filters) return null

  return (
    <>
      <Head>
        <title>Produkty cyfrowe | fansi.pl</title>
        <SEO description="Kupuj e-booki, planery, plansze, audiobooki i inne produkty cyfrowe stworzone przez Twoich ulubionych Twórców, z którymi zadbasz o swój umysł, ciało i duszę, dom i bliskich." />
      </Head>
      <GoogleAnalytics />
      <ProductsView
        filters={filters}
        productType={PRODUCT_TYPE}
        fansiKind={FansiKind.Digital}
      />
    </>
  )
}

DigitalProductsPage.Layout = Default

 const _getStaticProps: GetStaticProps = async () => {
  const staticFilters = await getFilters({ type: PRODUCT_TYPE })
  return { props: { staticFilters }, revalidate: 1 }
}

export default DigitalProductsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/digital/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  